import store from '@/store';
import S_answerSetting from '@/service/api/v1/answerSetting';

export default {
  async getNumConditionTypeFromValue(typeValue) {
    await S_answerSetting.updateNumConditionTypeListInVuex();
    const numConditionTypeList = store.state.model.numConditionTypeList;
    if (!typeValue || !numConditionTypeList || !numConditionTypeList.length) return;
    const tarConditionType = numConditionTypeList.find(type => type.type === typeValue);
    return tarConditionType ? tarConditionType : {};
  },
  async getNumConditionTypeFromId(typeId) {
    await S_answerSetting.updateNumConditionTypeListInVuex();
    const numConditionTypeList = store.state.model.numConditionTypeList;
    if (!typeId || !numConditionTypeList || !numConditionTypeList.length) return;
    const tarConditionType = numConditionTypeList.find(type => type.id === typeId);
    return tarConditionType ? tarConditionType : {};
  },
  setTempOptionBtnList(rawDataList) {
    return rawDataList.map(({id, name: text}) => ({id, text}));
  }
}